import styled from 'styled-components'
import theme from 'theme_'
import { CommonLinkButton } from 'components/Button'

export const DateCardFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px 16px 16px;
  gap: ${theme.spacing.base};
  margin-bottom: 15px;

  width: 1080px;
  max-width: 1080;
  height: 132px;

  /* White */
  background: #ffffff;
  /* Shadow small */
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  @media ${theme.devices.tablet} {
    width: 100%;
    flex-direction: row;
    gap: ${theme.spacing.xs};
    height: 132px;
  }

  @media ${theme.devices.tabletLandscape} {
    width: 100%;
    flex-direction: row;
    height: 132px;
  }

  @media ${theme.devices.mobile} {
    width: 100%;
    flex-direction: column;
    gap: ${theme.spacing.xs};
    height: 400px;
  }

  @media ${theme.devices.mediumDesktop} {
    width: 100%;
    flex-direction: row;
    height: 132px;
  }
`

export const DataCardLastColumn = styled.div`
    display: flex;
    min-width: 216px;
    flex-direction: column;
    alignItems: center;
    padding: 0px;
    gap: 5px;
    width: 216px;
    height: 100px;
    flex: none;
    order: 2;
    flexGrow: 0;,
    boxShadow: 10px 10px 10px rgba(0, 0, 0, 0.00);

    @media ${theme.devices.mobile} {
        width: 100%;
    }
`

export const ClassifierFrame = styled.div``

export const DataCardLastColumnHeader = styled.div``

export const DataCardLastColumnBody = styled.div``

export const NavigateToMistButton = styled(CommonLinkButton)`
  float: right;
`

export const NavigateToMistForwardIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.black};
`
